import { DashboardItemResponse, DashboardResponse } from '@/types/service-response'
import { GanttChartData } from '@/model/dashboard/GanttChartData'
import { DashboardMessage } from '@/model/dashboard/DashboardMessage'
import { DailyTableData } from '@/model/dashboard/DailyTableData'
import { PieChartData } from '@/model/dashboard/PieChartData'
import { ColumnChartData } from '@/model/dashboard/ColumnChartData'
import { ChartB2BB2CData } from '@/model/dashboard/ChartB2BB2CData'
import { ChartPHB2BB2CData } from '@/model/dashboard/ChartPHB2BB2CData'
import { ChartB2BB2CPData } from '@/model/dashboard/ChartB2BB2CPData'
import { ChartPHB2BB2CPData } from '@/model/dashboard/ChartPHB2BB2CPData'
import { ChartNewInactiveClientsData } from '@/model/dashboard/ChartNewInactiveClientsData'
import { ChartTPData } from '@/model/dashboard/ChartTPData'
import { ChartTAPData } from '@/model/dashboard/ChartTAPData'

export class DashboardData {
  public constructor (
    readonly code: string,
    readonly columnPosition: number,
    readonly rowPosition: number,
    readonly lastUpdatedDate: string,
    readonly widgetId: number,
    readonly widgetName: string,
    readonly widgetData: any,
  ) {}

  static createListFromResponse (responseData: DashboardResponse): Array<DashboardData> {
    return responseData.map((item: DashboardItemResponse) => {
      let widgetData: any = undefined

      if (item.widget_data) {
        if (item.code === 'w_schedule_daily') {
          widgetData = GanttChartData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_messages') {
          widgetData = DashboardMessage.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_schedule_daily_table') {
          widgetData = DailyTableData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_capacity_percentage') {
          widgetData = PieChartData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_capacity_by_employee' || item.code === 'w_bvg_by_employee') {
          widgetData = ColumnChartData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_schedule_week') {
          widgetData = GanttChartData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_turnover_b2b_b2c') {
          widgetData = ChartB2BB2CData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_plannedhours_b2b_b2c') {
          widgetData = ChartPHB2BB2CData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_turnover_b2b_b2c_percentage') {
          widgetData = ChartB2BB2CPData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_plannedhours_b2b_b2c_percentage') {
          widgetData = ChartPHB2BB2CPData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_new_inactive_clients') {
          widgetData = ChartNewInactiveClientsData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_turnover_products') {
          widgetData = ChartTPData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_turnover_additionalproducts') {
          widgetData = ChartTAPData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_turnover_allproducts') {
          widgetData = ChartTAPData.createListFromResponse(item.widget_data)
        }
      }

      return new DashboardData(
        item.code,
        item.column_position,
        item.row_position,
        item.data_last_updated_at,
        item.id_widget,
        item.widget_name,
        widgetData
      )
    })
  }
}
